<template lang="html">
	<div class="container-fluid p-5">
		<loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
		<div class="row">
			<div class="col-md-12">
				<div class="card">
					<div class="card-header">
						<h6>
							<button class="back-btn" type="button" @click="back()">
								<i class="fas fa-arrow-left"></i>
							</button>
							New Reveice
						</h6>
					</div>
					<div class="card-body">
						<form @submit.prevent="onSubmit">
							<div v-if="message" class="alert alert-danger">{{ message }}</div>
							<div class="form-group row">
								<div class="col-md-6">
									<label for="batchCode" class="col-form-label">Batch Code <span class="text-danger">*</span></label>
									<select v-model="reciptRequest.batch_id" @blur="validationRule()" class="form-control" id="batchCode" @change="getStudentCode()">
										<option value="">Select Batch Code</option>
										<option v-for="batch in batchCodeList" :key="batch.id" :value="batch.id">{{ batch.code1}}{{ batch.code2 }}{{ batch.code3 }}</option>
									</select>
									<small class="text-danger">{{validationData.batch_id}}</small>
								</div>
								<div class="col-md-6">
									<label for="studentCode" class="col-form-label">Student <span class="text-danger">*</span></label>
									<select v-model="reciptRequest.student_id" @blur="validationRule()" class="form-control" id="studentCode" @change="getEnrollment()">
										<option value="">Select Student</option>
										<option v-for="student in studentList" :key="student.id" :value="student.student_id">{{ student.name }}</option>
									</select>
									<small class="text-danger">{{validationData.student_id}}</small>
								</div>
							</div>
							<div v-if="Object.keys(enrollmentDetail).length > 0">
								<div class="form-group row">
									<div class="col-md-6">
										<label class="col-form-label">Fee Code</label>
										<input type="text" class="form-control" :value="enrollmentDetail.fee.code" readonly />
									</div>
									<div class="col-md-6">
										<label class="col-form-label">Payment Term</label>
										<input type="text" class="form-control" :value="enrollmentDetail.payment_term.name" readonly />
									</div>
								</div>
								<div class="form-group row" v-if="enrollmentDetail.discount">
									<div class="col-md-6">
										<label class="col-form-label">Discount Code</label>
										<input type="text" class="form-control" :value="enrollmentDetail.discount.code" readonly />
									</div>
									<div class="col-md-6">
										<label class="col-form-label">Discount Amount</label>
										<input type="text" class="form-control" :value="enrollmentDetail.discount_amount" readonly />
									</div>
								</div>
								<div class="form-group row">
									<div class="col-md-6">
										<label class="col-form-label">Total Fees</label>
										<input type="text" class="form-control" :value="enrollmentDetail.amount" readonly />
									</div>
									<div class="col-md-6">
										<label class="col-form-label">Original Fees</label>
										<input type="text" class="form-control" :value="enrollmentDetail.original_amount" readonly />
									</div>
								</div>
								<div class="form-group row">
									<div class="col-md-6">
										<label for="paymentMethod" class="col-form-label">Receipt Date<span class="text-danger">*</span></label>
										<input type="date" class="form-control" v-model="reciptRequest.receipt_date" />
										<small class="text-danger">{{validationData.receipt_date}}</small>
									</div>
									<div class="col-md-6">
										<label class="col-form-label">Receive Amount <span class="text-danger">*</span></label>
										<input type="number" class="form-control" v-model="reciptRequest.receive_amount" />
										<small class="text-danger">{{ validationData.receive_amount }}</small>
									</div>
								</div>
								
								<!-- Receipt Terms Section -->
								<!-- Debug Section -->
								<!-- <div v-if="Object.keys(enrollmentDetail).length > 0" class="alert alert-info">
									<strong>Debug Info:</strong><br>
									Receipt Terms Length: {{ reciptRequest.receiptTerms ? reciptRequest.receiptTerms.length : 'undefined' }}<br>
									Has Receipt Terms: {{ hasReceiptTerms }}<br>
									Raw Data: {{ JSON.stringify(reciptRequest.receiptTerms) }}
								</div> -->

								<div v-if="hasReceiptTerms" class="form-group">
									<h6>Payment Terms ({{ reciptRequest.receiptTerms.length }} terms)</h6>
									<div class="table-responsive">
										<table class="table table-bordered">
											<thead class="thead-light">
												<tr>
													<th>#Times</th>
													<th>Due Date</th>
													<!-- <th>Original Amount</th> -->
													<th>Amount</th>
													<th>Status</th>
													<th style="width:120px">Action</th>
												</tr>
											</thead>
											<tbody>
												<tr v-for="(term, index) in reciptRequest.receiptTerms" :key="term.id">
													<td>
														<input type="number" class="form-control" v-model.number="term.sort_order" :disabled="term.payment_status === 'approved'"/>
														<small class="text-danger">{{ validationData['receiptTerms.' + index + '.sort_order'] }}</small>
													</td>
													<td>
														<input type="date" class="form-control" v-model="term.due_date" :disabled="term.payment_status === 'approved'"/>
														<small class="text-danger">{{ validationData['receiptTerms.' + index + '.due_date'] }}</small>
													</td>
													<td style="display:none">
														<input type="number" class="form-control" v-model.number="term.original_amount" :disabled="term.payment_status === 'approved'"/>
														<small class="text-danger">{{ validationData['receiptTerms.' + index + '.original_amount'] }}</small>
													</td>
													<td>
														<input 
															type="number" 
															v-model.number="term.amount" 
															class="form-control" 
															:disabled="term.payment_status === 'approved'"
															:readonly="term.payment_status === 'approved'"
															@input="term.original_amount = term.amount"
														/>
														<small class="text-danger">{{ validationData['receiptTerms.' + index + '.amount'] }}</small>
													</td>
													<td>
														<div class="form-check">
															<input 
																class="form-check-input" 
																type="checkbox" 
																v-model="term.isChecked"
																@change="updateTermStatus(term, $event)"
																:disabled="term.payment_status === 'approved'"
																:id="'termStatus' + term.id"
															/>
															<label class="form-check-label" :for="'termStatus' + term.id">
																{{ getTermStatusLabel(term) }}
															</label>
														</div>
													</td>
													<td>
														<button type="button" class="btn btn-sm btn-success" @click="addReceiptTerm" v-if="index === reciptRequest.receiptTerms.length - 1"><i class="fas fa-plus"></i></button>
														<button type="button" class="btn btn-sm btn-danger" :class="{'ml-2': index === reciptRequest.receiptTerms.length - 1}" @click="removeReceiptTerm(index)" v-if="reciptRequest.receiptTerms.length > 1" :disabled="term.payment_status === 'approved'"><i class="fas fa-trash"></i></button>
													</td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>
							</div>
							<!-- Transfers: show one row by default, allow adding more -->
							<div class="form-group">
								<label class="col-form-label">Transfers</label>
								<div class="table-responsive">
									<table class="table table-sm table-bordered">
										<thead>
											<tr>
												<th>#</th>
												<th>Transfered Amount</th>
												<th>Bank Info</th>
												<th style="width:120px">Actions</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="(t, ti) in reciptRequest.transfers" :key="t.id">
												<td>{{ ti + 1 }}</td>
												<td>
													<input type="number" class="form-control" v-model.number="t.transfered_amount" />
													<small class="text-danger">{{ validationData['transfers.' + ti + '.transfered_amount'] }}</small>
												</td>
												<td>
													<select class="form-control" v-model="t.bank_info_id">
														<option value="">Select Bank Info</option>
														<option v-for="bank in bankInfo" :key="bank.id" :value="bank.id">{{ bank.bank_name }} - {{ bank.account_number }} - {{ bank.account_holder_name }}</option>
													</select>
													<small class="text-danger">{{ validationData['transfers.' + ti + '.bank_info_id'] }}</small>
												</td>
												<td>
													<button type="button" class="btn btn-sm btn-success" @click="addTransfer"><i class="fas fa-plus"></i></button>
													<button type="button" class="btn btn-sm btn-danger ml-2" @click="removeTransfer(ti)" v-if="reciptRequest.transfers.length > 1"><i class="fas fa-trash"></i></button>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>

							<button type="submit" class="btn btn-primary float-save">Submit</button>
						</form>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="js">
	import {
		mapState,
		mapActions
	} from 'vuex'
	import env from '../../enviorments'
	import Loading from 'vue-loading-overlay'
	import 'vue-loading-overlay/dist/vue-loading.css';
	export default {
		name: 'enrollmentCreate',
		metaInfo: {
            title: "Enrollment Create",
            titleTemplate: "%s ← MIC",
        },
		components: {
			Loading
		},
		data() {
			return {
				env,
				isLoading: false,
				fullPage: true,
				message: "",
				batchCodeList: [],
				discountList: [],
				feeCodeList: [],
				termList: [],
				paymentMethod: [],
				bankInfo: [],
				originalFeeAmount: 0,
				enrollmentDetail: {},
				suppressEnforce: false,
				reciptRequest: {
					enrollment_id: "",
					batch_id: "",
					student_id: "",
					receive_amount: "",
					partial_amount: "",
					partial_approved: false,
					payment_method_id: 1,
					bank_info_id: 1,
					receipt_date: "",
					note: "",
					receiptTerms: [],
					// new transfers array to support multiple transfer entries
					transfers: [
						{ id: 1, transfered_amount: '', bank_info_id: '' }
					]
				},
				validationData: {
					batch_id: "",
					student_id: "",
					receive_amount: "",
					receipt_date: "",
					received_amount: "",
				}
			}
		},
		watch: {
			async $route(to, from) {
			},
			// 'reciptRequest.receive_amount': function(newVal, oldVal) {
			// 	this.distributeReceiveAmount();
			// }
			// ,'reciptRequest.receiptTerms': {
			// 	handler(newVal, oldVal) {
			// 		if (this.suppressEnforce) return;
			// 		this.enforceTermsSum();
			// 	},
			// 	deep: true
			// }
		},
		computed: {
			hasReceiptTerms() {
				return this.reciptRequest.receiptTerms && this.reciptRequest.receiptTerms.length > 0;
			}
		},
		methods: {
			...mapActions({
				receiptStoreAction: 'receiptStoreAction',
				getBatchCodeAction: 'getBatchCodeAction',
				getStudentCodeAction: 'getStudentCodeAction',
				getEnrollmentAction: 'getEnrollmentAction',
				getBankDetailsAction: 'getBankDetailsAction',
			}),

			// Transfer helpers
			addTransfer() {
				const nextId = (this.reciptRequest.transfers.length ? Math.max(...this.reciptRequest.transfers.map(t => t.id)) : 0) + 1;
				this.reciptRequest.transfers.push({ id: nextId, transfered_amount: '', bank_info_id: '' });
			},

			removeTransfer(index) {
				this.reciptRequest.transfers.splice(index, 1);
			},

			// Receipt Terms helpers
			addReceiptTerm() {
				const terms = this.reciptRequest.receiptTerms || [];
				const nextId = (terms.length ? Math.max(...terms.map(t => t.id)) : 0) + 1;
				
				// Auto-complete #Times (sort_order) based on the max value currently in the list
				let nextSortOrder = 1;
				if (terms.length > 0) {
					const maxSortOrder = Math.max(...terms.map(t => Number(t.sort_order) || 0));
					nextSortOrder = maxSortOrder + 1;
				}

				this.reciptRequest.receiptTerms.push({ 
					id: nextId, 
					sort_order: nextSortOrder, 
					due_date: '', 
					original_amount: 0, 
					amount: 0, 
					payment_status: 'pending', 
					isChecked: false 
				});
				
				this.recalculateSortOrders();
			},

			removeReceiptTerm(index) {
				this.reciptRequest.receiptTerms.splice(index, 1);
				this.recalculateSortOrders();
			},

			recalculateSortOrders() {
				// Re-sequence the sort_order to ensure "#Times" is linear and correct
				if (this.reciptRequest.receiptTerms && this.reciptRequest.receiptTerms.length > 0) {
					this.reciptRequest.receiptTerms.forEach((term, idx) => {
						term.sort_order = idx + 1;
					});
				}
			},

			async getBankDetails(){
				this.isLoading = true
				let option = {}
				await this.getBankDetailsAction({
					...option
				}).then(res => {
					if(res.success === true) {
						this.paymentMethod = res.data.payment_methods
						this.bankInfo = res.data.bank_infos
					}
					this.isLoading = false
				}).catch(err => this.isLoading = true)
			},

			async getBatchCode(){
				await this.getBatchCodeAction().then(res => {
					this.batchCodeList = res.data
					this.isLoading = false
				}).catch(err => this.isLoading = true)
			},

			async getStudentCode(){
				this.isLoading = true
				// Reset when batch changes
				this.reciptRequest.student_id = '';
				this.resetReceiptTerms();
				
				let option = {
					batch_id: this.reciptRequest.batch_id
				}
				await this.getStudentCodeAction({
					...option
				}).then(res => {
					this.studentList = res.data
					this.isLoading = false
				}).catch(err => this.isLoading = true)
			},

			async getEnrollment(){
				this.isLoading = true
				let option = {
					student_id: this.reciptRequest.student_id,
					batch_id: this.reciptRequest.batch_id
				}
				await this.getEnrollmentAction({
					...option
				}).then(res => {
					if(res.success === true) {
						console.log("Enrollment data:", res.data)
						this.enrollmentDetail = res.data
						this.reciptRequest.enrollment_id = res.data.id
						this.reciptRequest.receive_amount = res.data.receive_amount
						this.reciptRequest.partial_amount = res.data.partial_amount
						this.reciptRequest.partial_approved = res.data.partial_approved
						
						// Initialize receipt terms properly
						if(res.data.receipts_terms && res.data.receipts_terms.length > 0) {
							// console.log("Receipt terms found:", res.data.receipts_terms)
							this.$set(this.reciptRequest, 'receiptTerms', res.data.receipts_terms.map(term => {
											const status = term.status || 'pending';
											return {
												id: term.id || Math.random(),
												sort_order: term.sort_order || 1,
												due_date: term.due_date || 0,
												amount: term.amount || '',
												original_amount: term.original_amount || 0,
												payment_status: status,
												isChecked: status === 'completed' || status === 'approved'
											};
							}));
							// Ensure terms' original_amounts sum to total fees
							// this.normalizeReceiptTermsAmounts();
							console.log("Processed receipt terms:", this.reciptRequest.receiptTerms)
						} else {
							console.log("No receipt terms found, setting empty array")
							this.$set(this.reciptRequest, 'receiptTerms', []);
						}
					}
					this.isLoading = false
				}).catch(err => this.isLoading = true)
			},

			// Watch and distribute receive amount across terms when it changes
			distributeReceiveAmount() {
				const receive = parseFloat(this.reciptRequest.receive_amount);
				if (!receive || isNaN(receive)) return;
				const terms = this.reciptRequest.receiptTerms || [];
				if (!terms.length) return;
				// find first non-approved term to be the target for the receive amount
				let targetIndex = terms.findIndex(t => t.payment_status !== 'approved');
				if (targetIndex === -1) {
					// all approved, nothing to apply
					this.$set(this.reciptRequest, 'unapplied_amount', receive);
					return;
				}
				// ensure amounts exist
				terms.forEach(t => {
					if (t.amount === undefined || t.amount === null || t.amount === '') t.amount = Number(t.original_amount || 0);
				});

				// Set target term to the receive amount (overwrite applied for that term)
				const oldTarget = parseFloat(terms[targetIndex].amount) || 0;
				let delta = Number((receive - oldTarget).toFixed(2));
				this.$set(terms[targetIndex], 'amount', Number(receive.toFixed(2)));
				this.$set(terms[targetIndex], 'isChecked', receive > 0);
				this.$set(terms[targetIndex], 'payment_status', receive > 0 ? 'completed' : 'pending');

				// If delta > 0, we need to remove amounts from subsequent terms to keep schedule sum constant
				// If delta < 0, we need to push freed amount to subsequent terms up to their original_amount
				let remaining = Math.abs(delta);
				if (delta > 0) {
					for (let j = targetIndex + 1; j < terms.length && remaining > 0; j++) {
						const donor = parseFloat(terms[j].amount) || 0;
						if (terms[j].payment_status === 'approved' || donor <= 0) continue;
						const take = Math.min(donor, remaining);
						this.$set(terms[j], 'amount', Number((donor - take).toFixed(2)));
						remaining = Number((remaining - take).toFixed(2));
					}
					// any remaining amount becomes unapplied
					this.$set(this.reciptRequest, 'unapplied_amount', Number(remaining.toFixed(2)));
				} else if (delta < 0) {
					// distribute freed amount to subsequent terms up to their original_amount
					for (let j = targetIndex + 1; j < terms.length && remaining > 0; j++) {
						if (terms[j].payment_status === 'approved') continue;
						const cap = parseFloat(terms[j].original_amount) || 0;
						const current = parseFloat(terms[j].amount) || 0;
						const space = Math.max(0, cap - current);
						const give = Math.min(space, remaining);
						this.$set(terms[j], 'amount', Number((current + give).toFixed(2)));
						remaining = Number((remaining - give).toFixed(2));
					}
					// if any freed amount remains, reduce unapplied_amount accordingly
					this.$set(this.reciptRequest, 'unapplied_amount', Math.max(0, (parseFloat(this.reciptRequest.unapplied_amount) || 0) - remaining));
				}

				// update terms
				this.$set(this.reciptRequest, 'receiptTerms', terms);
			},

			enforceTermsSum() {
				const terms = this.reciptRequest.receiptTerms || [];
				if (!terms.length) return;
				const totalFee = parseFloat(this.enrollmentDetail.amount) || 0;
				const sum = terms.reduce((s, t) => s + (parseFloat(t.amount) || 0), 0);
				const diff = Number((totalFee - sum).toFixed(2));
				if (Math.abs(diff) < 0.01) return; // already balanced
				// find last non-approved term to adjust
				for (let i = terms.length -1; i >=0; i--) {
					if (terms[i].payment_status !== 'approved') {
						this.suppressEnforce = true;
						const newAmt = Number(((parseFloat(terms[i].amount) || 0) + diff).toFixed(2));
						this.$set(terms[i], 'amount', newAmt < 0 ? 0 : newAmt);
						this.suppressEnforce = false;
						this.$set(this.reciptRequest, 'receiptTerms', terms);
						return;
					}
				}
			},
			async onSubmit() {
				this.isLoading = true
				let validation = this.validationRule()
				if (validation == true) {
					this.isLoading = false
					return
				}
		
				const formData = new FormData();
				formData.append('enrollment_id', this.reciptRequest.enrollment_id);
				formData.append('batch_id', this.reciptRequest.batch_id);
				formData.append('student_id', this.reciptRequest.student_id);
				formData.append('receive_amount', this.reciptRequest.receive_amount);
				formData.append('last_extra_amount', this.reciptRequest.partial_amount);
				formData.append('payment_method_id', this.reciptRequest.payment_method_id);
				formData.append('bank_info_id', this.reciptRequest.bank_info_id);
				formData.append('note', this.reciptRequest.note);
				formData.append('receipt_terms', JSON.stringify(this.reciptRequest.receiptTerms));
				// include transfers (supports multiple transfer entries)
				formData.append('transfers', JSON.stringify(this.reciptRequest.transfers || []));
				formData.append('receipt_date', this.reciptRequest.receipt_date);

				await this.receiptStoreAction(
					formData
				).then(res => {
					if(res.success === true) {
						this.back()
					} else {
						this.message = res.message
					}
					this.isLoading = false
				}).catch(err => this.isLoading = true)
			},
			back() {
				this.$router.replace({ 
					path: '/receipt-list', 
					query: {
						page: 1, 
						per_page: 10,
						sort_direction: 'desc', 
						sort_by: 'created_at',
						search_receipt: '',
						search_batch: '',
						search_fee: '',
						search_student: '',
						date_from: '',
						date_to: ''
					}
				}).catch(()=>{})
			},
			validationRule() {
				this.message = "";
				let isValidation = []
				
				if (this.reciptRequest.batch_id == "") {
					this.validationData.batch_id = "The batch field is required."
					isValidation.push(true)
				} else {
					this.validationData.batch_id = ""
					isValidation.push(false)
				}
				
				if (this.reciptRequest.student_id == "") {
					this.validationData.student_id = "The student field is required."
					isValidation.push(true)
				} else {
					this.validationData.student_id = ""
					isValidation.push(false)
				}

				if(this.reciptRequest.receipt_date == "") {
					this.validationData.receipt_date = "The receipt date field is required."
					isValidation.push(true)
				} else {
					this.validationData.receipt_date = ""
					isValidation.push(false)
				}

				if(this.receive_amount == "") {
					this.validationData.receive_amount = "The receive amount must be a positive number."
					isValidation.push(true)
				} else {
					this.validationData.receive_amount = ""
					isValidation.push(false)
				}

				let isAnyTermChecked = false;
				let paidAmountTotal = 0;
				// validate receipt terms array
				if (this.reciptRequest.receiptTerms && this.reciptRequest.receiptTerms.length) {
					let sumOriginalAmount = 0;
					let sumAmount = 0;
					this.reciptRequest.receiptTerms.forEach((term, idx) => {
						sumOriginalAmount += parseFloat(term.original_amount) || 0;
						sumAmount += parseFloat(term.amount) || 0;
						const timesKey = 'receiptTerms.' + idx + '.sort_order';
						const dueDateKey = 'receiptTerms.' + idx + '.due_date';
						const origAmtKey = 'receiptTerms.' + idx + '.original_amount';
						const amtKey = 'receiptTerms.' + idx + '.amount';

						if (!term.sort_order && term.sort_order !== 0) {
							this.$set(this.validationData, timesKey, 'Required.');
							isValidation.push(true);
						} else {
							this.$set(this.validationData, timesKey, '');
							isValidation.push(false);
						}

						if (!term.due_date) {
							this.$set(this.validationData, dueDateKey, 'Required.');
							isValidation.push(true);
						} else {
							this.$set(this.validationData, dueDateKey, '');
							isValidation.push(false);
						}

						if (!term.original_amount && term.original_amount !== 0) {
							this.$set(this.validationData, origAmtKey, 'Required.');
							isValidation.push(true);
						} else {
							this.$set(this.validationData, origAmtKey, '');
							isValidation.push(false);
						}

						if (!term.amount && term.amount !== 0) {
							this.$set(this.validationData, amtKey, 'Required.');
							isValidation.push(true);
						} else {
							this.$set(this.validationData, amtKey, '');
							isValidation.push(false);
						}

						if (term.payment_status === 'completed') {
							isAnyTermChecked = true;
							paidAmountTotal += parseFloat(term.amount) || 0;
						}
					});

					if (!isAnyTermChecked) {
						this.message = "At least one payment term must be marked as paid.";
						isValidation.push(true);
						return true; // no need to continue if this basic condition fails
					}

					const totalFee = parseFloat(this.enrollmentDetail.amount) || 0;
					const sumOriginalRounded = Number(sumOriginalAmount.toFixed(2));
					const sumAmountRounded = Number(sumAmount.toFixed(2));
					const totalFeeRounded = Number(totalFee.toFixed(2));
					const receiveRounded = Number((parseFloat(this.reciptRequest.receive_amount) || 0).toFixed(2));

					console.log(`Validation sums - Original: ${sumOriginalRounded}, Amount: ${sumAmountRounded}, Total Fee: ${totalFeeRounded}`);
					console.log(`Paid Amount Total: ${paidAmountTotal}`);

					// Validate that original amounts and amounts do not exceed total fees, and that amounts match total fees exactly
					if (receiveRounded > totalFeeRounded) {
						this.message = `The total of Original Amounts (${receiveRounded}) cannot be greater than the Total Fees (${totalFeeRounded}).`;
						isValidation.push(true);
					} else if (sumAmountRounded > totalFeeRounded) {
						this.message = `The total of Amounts (${sumAmountRounded}) cannot be greater than the Total Fees (${totalFeeRounded}).`;
						isValidation.push(true);
					} else if (sumAmountRounded < totalFeeRounded) {
						this.message = `The total of Amounts (${sumAmountRounded}) is less than the Total Fees (${totalFeeRounded}). They must be exactly equal.`;
						isValidation.push(true);
					}

					// Ensure paid amount total matches the receive amount
					if(paidAmountTotal > receiveRounded) {
						this.message = `The total of paid Amounts (${paidAmountTotal}) cannot be greater than the Receive Amount (${receiveRounded}).`;
						isValidation.push(true);
					}else if (paidAmountTotal < receiveRounded) {
						this.message = `The total of paid Amounts (${paidAmountTotal}) cannot be less than the Receive Amount (${receiveRounded}).`;
						isValidation.push(true);
					}

				}

				// validate transfers array (multi-transfer support)
				if (this.reciptRequest.transfers && this.reciptRequest.transfers.length) {
					this.reciptRequest.transfers.forEach((t, idx) => {
						const amtKey = 'transfers.' + idx + '.transfered_amount';
						const bankKey = 'transfers.' + idx + '.bank_info_id';
						if (!t.transfered_amount || Number(t.transfered_amount) <= 0) {
							this.$set(this.validationData, amtKey, 'The transfered amount is required.');
							isValidation.push(true);
						} else {
							this.$set(this.validationData, amtKey, '');
							isValidation.push(false);
						}

						if (!t.bank_info_id) {
							this.$set(this.validationData, bankKey, 'The bank info field is required.');
							isValidation.push(true);
						} else {
							this.$set(this.validationData, bankKey, '');
							isValidation.push(false);
						}
					});
				}

				// validate sum of transfers equals receive_amount (if receive_amount provided)
				const receiveVal = parseFloat(this.reciptRequest.receive_amount) || 0;
				const sumTransfers = (this.reciptRequest.transfers || []).reduce((s, t) => s + (parseFloat(t.transfered_amount) || 0), 0);
				if (receiveVal > 0) {
					if (Math.abs(sumTransfers - receiveVal) > 0.001) {
						this.validationData.receive_amount = 'Sum of transfers must equal the receive amount.';
						isValidation.push(true);
					} else {
						this.validationData.receive_amount = '';
						isValidation.push(false);
					}
				} else {
					// clear any previous message
					this.validationData.receive_amount = '';
				}
				
				if (isValidation.includes(true)) {
					return true
				} else {
					return false
				}
			},
			calculateTotalReceived() {
				return this.reciptRequest.receiptTerms.reduce((total, term) => {
					return total + (parseFloat(term.amount) || 0);
				}, 0);
			},
			resetReceiptTerms() {
				this.$set(this.reciptRequest, 'receiptTerms', []);
				this.enrollmentDetail = {};
				this.reciptRequest.receive_amount = '';
				console.log("Receipt terms reset");
			},
			updateTermStatus(term, event) {
					// Prevent changes if status is approved
					if (term.payment_status === 'approved') {
						return;
					}

					// Save previous state to allow revert on validation failure
					const prevState = {
						payment_status: term.payment_status,
						isChecked: term.isChecked,
						amount: term.amount
					};

					if (event.target.checked) {
						// Tentatively mark as completed
						this.$set(term, 'payment_status', 'completed');
						this.$set(term, 'isChecked', true);
						let amountWasEmpty = false;
						if (term.amount === '' || term.amount === undefined || term.amount === null) {
							amountWasEmpty = true;
							this.$set(term, 'amount', term.original_amount || 0);
						}

						// Run validation; if invalid, revert the change and uncheck
						const invalid = this.validationRule();
						if (invalid) {
							this.$set(term, 'payment_status', "completed");
							this.$set(term, 'isChecked', prevState.isChecked);
							this.$set(term, 'amount', prevState.amount);
							if (event && event.target) event.target.checked = false;
							return;
						}
					} else {
						// Mark as pending when unchecked
						this.$set(term, 'payment_status', 'pending');
						this.$set(term, 'isChecked', false);
					}
			},
			getTermStatusLabel(term) {
				if (term.payment_status === 'approved') {
					return 'Paid (Approved)';
				}
				if (term.payment_status === 'completed' || term.isChecked) {
					return 'Paid';
				}
				return 'Pending';
			}
		},
		async mounted() {
			await this.getBatchCode()
			await this.getBankDetails()
		}
	}
</script>

<style scoped lang="scss">
	.v-text-field--box .v-input__slot,
	.v-text-field--outline .v-input__slot {
		min-height: 56px;
	}
	.banner-image {
		width: 100px;
		height: 100px;
		object-fit: contain;
	}
</style>